import React, { ReactNode } from 'react';
import PatientIdentification from '../../../pages/PatientIdentification';
import Configurator from '../../../pages/Configurator';
import DateTime from '../../../pages/DateTime';
import ServiceList from '../../../pages/ServiceList';
import PaymentView from '../../../pages/PaymentView';
import ServiceTypePage from '../../../pages/ServiceTypePage';
import AppointmentConfirmationList from '../../../pages/AppointmentConfirmationList';
import { AppointmentConclusion } from '../../../pages/AppointmentConclusion';
import ResourceDetails from '../Pages/ResourceDetails';
import { ProductSelector } from '../../../pages/ProductSelector';
import SpecialistDetails from '../../../pages/SpecialistDetails';
import { UnitAuxiliaryInfo } from '../../../pages/UnitAuxiliaryInfo';
import SpecialistList from '../../../pages/SpecialistList';
import AppointmentTypeSpecialist from '../../../flows/Specialist/pages/AppointmentTypeSpecialist';
import { ProductList } from '../../../flows/APS/pages';

import PatientIdentificationSpecialist from '../../Specialist/pages/PatientIdentification';
import { PregnantInfo } from '../Pages/PregnantInfo';

type PageProps = {
  [x: number]: ReactNode;
};

export const PAGES_COMPONENTS: PageProps = {
  1: <ServiceList />,
  2: <PatientIdentification />,
  3: <Configurator />,
  4: <PaymentView />,
  5: <ServiceTypePage />,
  6: <DateTime />,
  7: <AppointmentConfirmationList />,
  8: <AppointmentConclusion />,
  11: <ResourceDetails />,
  13: <ProductSelector />,
  14: <SpecialistDetails />,
  15: <UnitAuxiliaryInfo />,
  16: <SpecialistList />,
  20: <AppointmentTypeSpecialist />,
  21: <PatientIdentificationSpecialist />,
  22: <PregnantInfo />,
  23: <PregnantInfo />,
  24: <ProductList />
};
